import React from 'react';
import { YStack } from 'smoothie';

import { PageContentContainer } from '../../common/components/GroveContainers';
import { GuideMessagingWidget } from './GuideMessagingWidget';
import { MessagingTools } from './MessagingTools/MessagingTools';

export const GuideMessagingPage = () => {
    return (
        <YStack width="94%" marginVertical="2vh">
            <PageContentContainer
                padding={0}
                marginTop={0}
                $lg={{ padding: 0, marginHorizontal: '1%' }}
                backgroundColor="transparent"
            >
                <MessagingTools />
            </PageContentContainer>
            <PageContentContainer>
                <GuideMessagingWidget />
            </PageContentContainer>
        </YStack>
    );
};
